export default function articleLoader() {
    const feed = document.querySelector("[data-article-feed]");
    const sentinel = document.querySelector("[data-load-more]");
    if (!feed || !sentinel) return;

    const api = sentinel.dataset.api;
    const cfg = document.querySelector("script[data-key]");
    const key = cfg && cfg.dataset.key;
    if (!api || !key) { sentinel.remove(); return; }

    const limit = 12;
    let page = 2;
    let loading = false;
    let done = false;

    const esc = (s) => (s || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
    const sized = (u) => (u && u.indexOf("/content/images/") > -1 ? u.replace("/content/images/", "/content/images/size/w700/") : u);
    const trim = (s, n) => { const w = (s || "").trim().split(/\s+/); return w.length > n ? w.slice(0, n).join(" ") + "…" : (s || ""); };

    const card = (p) => {
        const t = p.primary_tag;
        const tag = t ? `<a class="gh-kick gh-card-tag" href="${esc(t.url)}">${esc(t.name)}</a>` : "";
        const img = p.feature_image ? `<span class="gh-card-img gh-duo" style="background-image:url('${esc(sized(p.feature_image))}')"></span>` : "";
        const a = p.primary_author;
        let byline = "";
        if (a) {
            const avatar = a.profile_image ? `<img class="gh-avatar" src="${esc(sized(a.profile_image))}" alt="${esc(a.name)}" width="28" height="28">` : "";
            const meta = `<a href="${esc(a.url)}">${esc(a.name)}</a>${t ? " &middot; " + esc(t.name) : ""} &middot; ${p.reading_time || 1} min read`;
            byline = `<div class="gh-byline">${avatar}<span class="gh-meta">${meta}</span></div>`;
        }
        return `<article class="gh-card">${img}${tag}<h3 class="gh-card-title"><a class="gh-card-link" href="${esc(p.url)}">${esc(p.title)}</a></h3><p class="gh-card-excerpt">${esc(trim(p.excerpt, 20))}</p>${byline}</article>`;
    };

    const stop = () => { done = true; io.disconnect(); sentinel.remove(); };

    const load = async () => {
        if (loading || done) return;
        loading = true;
        sentinel.classList.add("is-loading");
        try {
            const res = await fetch(`${api}/posts/?key=${key}&limit=${limit}&page=${page}&include=tags,authors`);
            const data = await res.json();
            const posts = data.posts || [];
            if (posts.length) feed.insertAdjacentHTML("beforeend", posts.map(card).join(""));
            const meta = data.meta && data.meta.pagination;
            if (!meta || !meta.next) stop();
            else page = meta.next;
        } catch (e) {
            stop();
        }
        loading = false;
        sentinel.classList.remove("is-loading");
    };

    const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) load();
    }, { rootMargin: "500px" });
    io.observe(sentinel);
}
